$(function (){

  if (!window.NutsacA11yPopup) {
    var popupOpeners = {};

    function getPopupFocusable($root) {
      return $root.find(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ).filter(':visible');
    }

    function closeA11yPopup(selector) {
      var $modal = $(selector);
      if (!$modal.length || $modal.is('[hidden]')) return;

      $modal.attr('hidden', true);
      $('#main-content, footer, header, .navigation-bar').removeAttr('aria-hidden');

      var id = $modal.attr('id');
      if (id) {
        $(document).off('keydown.a11ypopup-' + id);
        if (popupOpeners[id]) {
          $(popupOpeners[id]).focus();
          popupOpeners[id] = null;
        }
      }
    }

    function openA11yPopup(selector, opener) {
      var $modal = $(selector);
      if (!$modal.length) return;

      var id = $modal.attr('id') || 'dialog';
      popupOpeners[id] = opener || document.activeElement;

      $modal.removeAttr('hidden');
      $('#main-content, footer, header, .navigation-bar').attr('aria-hidden', 'true');

      setTimeout(function () {
        var $close = $modal.find('.a11y-product-popup-close').first();
        var $focusable = getPopupFocusable($modal);
        ($close.length ? $close : $focusable.first()).focus();
      }, 50);

      $(document).on('keydown.a11ypopup-' + id, function (e) {
        if (e.key === 'Escape') {
          closeA11yPopup(selector);
          return;
        }
        if (e.key !== 'Tab') return;

        var $focusable = getPopupFocusable($modal);
        if (!$focusable.length) return;

        var $first = $focusable.first();
        var $last = $focusable.last();

        if (e.shiftKey && $(document.activeElement).is($first)) {
          e.preventDefault();
          $last.focus();
        } else if (!e.shiftKey && $(document.activeElement).is($last)) {
          e.preventDefault();
          $first.focus();
        }
      });
    }

    window.NutsacA11yPopup = {
      open: openA11yPopup,
      close: closeA11yPopup
    };

    $(document).on('click', '[data-a11y-popup-close], .a11y-product-popup-backdrop', function (e) {
      var $modal = $(this).closest('.a11y-product-popup');
      if ($modal.length) {
        e.preventDefault();
        closeA11yPopup('#' + $modal.attr('id'));
      }
    });

    $('#kevlar-info').on('click', function (e) {
      e.preventDefault();
      openA11yPopup('#kevlar-info-modal', this);
    });

    if (window.location.href.indexOf('redirect=kevlar') > -1) {
      openA11yPopup('#kevlar-info-modal');
    }
  }

  $('.yt-reviews').on('click', function(){
    
    if ( $('.product-video').hasClass('slick-initialized')) {    
    }
    
    else {
    $('.product-video').slick({
      dots: true,
      prevArrow: false,
      nextArrow: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear'
    });
      
    }
    
    $('.product-images').addClass('hide');
    $('.product-images-indicator').addClass('hide');
    $('.yt-reviews-container').addClass('hide');
    $('.product-video').removeClass('hide');
    $('.thumbnails-arrows').addClass('hide');

    $('.product-images-container').addClass('video-css');
    
    $('.product-options').on('click', function(){
    $('.product-images').removeClass('hide');
    $('.product-video').addClass('hide');
    $('.product-images-indicator').removeClass('hide');
    $('.thumbnails-arrows').removeClass('hide')

    $('.product-images-container').removeClass('video-css');
    $('.yt-reviews-container').removeClass('hide');



    });

  });

});  



var video_wrapper = $('.youtube-video-place');
//  Check to see if youtube wrapper exists

if(video_wrapper.length){
// If user clicks on the video wrapper load the video.
$('.play-youtube-video').on('click', function(){ //change selector class
  var plop = $(this).data('yt-url');
  var vidIndex = $(this).data('video-index');
   
  $("#youtube-video-"+ vidIndex +"").html('<iframe allowfullscreen frameborder="0" style="width:100%; height:100%"; class="embed-responsive-item" src="' + plop + '"></iframe>');

 
});
  
  $('.video-button').on('click', function(){ //change selector class
  
   var videoId = $(this).data('video-url');
  $(".product-video-info").attr("aria-hidden", "true").attr("role", "presentation").html('<iframe width="560" height="315" src="https://www.youtube.com/embed/'+ videoId +'?rel=0&showinfo=0&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen title="" tabindex="-1" aria-hidden="true"></iframe>');

 
});
  
}

if ($('.page-product-custom')) {
  /*
  $('.product-thumbnails').each(function(e) {
    var color = $(this).attr('data-color');
    $('.thumbnails-'+color).slick({
      slidesToShow: 6,
      slidesToScroll: 6,
      vertical: true,
      asNavFor: '.gallery-'+color,
      dots: false,
      focusOnSelect: true,
      verticalSwiping: true,
      responsive: [
        {
            breakpoint: 1023,
            settings: {
              vertical: false,
               slidesToShow: 4,
              slidesToScroll: 2,
              verticalSwiping:false
            }
        }
      ]
    });
  });
  
  $('[data-option="Color"] .product-form-option').on('click', function(){
    var color = $(this).val();
    $('.product-thumbnails').attr('data-active', false);
    $('.thumbnails-'+color).attr('data-active', true);
  });
  */

  $('.product-thumbnails').slick({
      slidesToShow: 8,
      slidesToScroll: 8,
      vertical: true,
      asNavFor: '.product-gallery',
      dots: false,
      focusOnSelect: true,
      verticalSwiping: true,
      infinite: false,
      responsive: [
        {
            breakpoint: 1023,
            settings: {
              vertical: false,
               slidesToShow: 5,
              slidesToScroll: 2,
              verticalSwiping:false
            }
        }
      ]
    });

  $('.moreless-button').click(function(e) {
    e.preventDefault();
    $('.product-description').toggleClass('show');
    if ($('.moreless-button').text() == "READ MORE") {
      $(this).text("READ LESS");
    } else {
      $(this).text("READ MORE");
    }
  });

  $('.faq-tab-content-question').on('click', function(e){
    e.preventDefault();
    var $btn = $(this);
    var $content = $btn.closest('.faq-tab-content');
    var isOpen = $content.toggleClass('is-open').hasClass('is-open');
    $btn.attr('aria-expanded', isOpen);
    $btn.find('span').text(isOpen ? '-' : '+');
    $('#' + $btn.attr('aria-controls')).prop('hidden', !isOpen);
  });

  $('#goes-with-add').on('click', function(){
    $(this).addClass('added').delay(3000).queue(function( next ){
        $(this).removeClass('added'); 
        next();
    });
  });

  $('#quantity-decrease').on('click', function(){
    var qty = $('#quantity-value').text();
    if (parseInt(qty) > 1) {
      $('#quantity-value').text(parseInt(qty)-1);
      $('#add-to-cart').attr('data-cart-quantity', parseInt(qty)-1);
    }
  });

  $('#quantity-increase').on('click', function(){
    var qty = $('#quantity-value').text();
    $('#quantity-value').text(parseInt(qty)+1);
    $('#add-to-cart').attr('data-cart-quantity', parseInt(qty)+1);
  });

  var $sizeChartModal = $('.size-chart-modal');
  var sizeChartOpener = null;

  function syncSizeChartTabOrder(isOpen) {
    if (!$sizeChartModal.length) return;
    var selector = 'a[href], button, input, select, textarea, [tabindex]';
    if (isOpen) {
      $sizeChartModal.removeAttr('aria-hidden');
      $sizeChartModal.find(selector).each(function () {
        var $el = $(this);
        var saved = $el.attr('data-sizechart-tabindex');
        if (saved !== undefined) {
          saved === '' ? $el.removeAttr('tabindex') : $el.attr('tabindex', saved);
          $el.removeAttr('data-sizechart-tabindex');
        } else {
          $el.removeAttr('tabindex');
        }
      });
    } else {
      $sizeChartModal.attr('aria-hidden', 'true');
      $sizeChartModal.find(selector).each(function () {
        var $el = $(this);
        if ($el.attr('data-sizechart-tabindex') === undefined) {
          $el.attr('data-sizechart-tabindex', $el.attr('tabindex') || '');
        }
        $el.attr('tabindex', '-1');
      });
    }
  }

  function closeSizeChartModal() {
    $sizeChartModal.removeClass('open');
    $('body').removeClass('no-scroll');
    $('#main-content, footer, .navigation-bar').removeAttr('aria-hidden');
    syncSizeChartTabOrder(false);
    $(document).off('keydown.sizechart');
    if (sizeChartOpener) {
      $(sizeChartOpener).focus();
      sizeChartOpener = null;
    }
  }

  function openSizeChartModal(opener) {
    sizeChartOpener = opener;
    $sizeChartModal.addClass('open');
    $('body').addClass('no-scroll');
    $('#main-content, footer, .navigation-bar').attr('aria-hidden', 'true');
    syncSizeChartTabOrder(true);
    setTimeout(function () {
      $('#modal-close').focus();
    }, 50);

    $(document).on('keydown.sizechart', function (e) {
      if (e.key === 'Escape') {
        closeSizeChartModal();
        return;
      }
      if (e.key !== 'Tab' || !$sizeChartModal.hasClass('open')) return;

      var $focusable = $sizeChartModal.find(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ).filter(':visible');

      if ($focusable.length === 0) return;

      var $first = $focusable.first();
      var $last = $focusable.last();

      if (e.shiftKey && $(document.activeElement).is($first)) {
        e.preventDefault();
        $last.focus();
      } else if (!e.shiftKey && $(document.activeElement).is($last)) {
        e.preventDefault();
        $first.focus();
      }
    });
  }

  $('#size-chart-open').on('click', function(e){
    e.preventDefault();
    openSizeChartModal(this);
  });

  $('#modal-close').on('click', function(e){
    e.preventDefault();
    closeSizeChartModal();
  });

  $sizeChartModal.on('click', function(e) {
    if ($(e.target).is('.size-chart-modal-backdrop')) {
      closeSizeChartModal();
    }
  });

  syncSizeChartTabOrder(false);

}

if ($('.page-product-custom-new').length) {

  function syncThumbnailsForColor(color) {
    $('.thumbnails-arrows').attr('data-active', false);

    if($('.thumbnails-arrows[data-color="'+color+'"]').attr("data-upgrade")) {
      var upgrade = $('[data-option="TacSac Upgrade"] input[type="radio"]:checked').val();
      $('.thumbnails-arrows[data-color="'+color+'"][data-upgrade="'+upgrade+'"]').attr('data-active', true);
      $('.product-thumbnails-new[data-color="'+color+'"][data-upgrade="'+upgrade+'"]').slick('reinit');
    } else {
      $('.thumbnails-arrows[data-color="'+color+'"]').attr('data-active', true);
      $('.product-thumbnails-new[data-color="'+color+'"]').slick('reinit');
    }
  }

  function syncVariantGallery() {
    var $form = $('.page-product-custom-new form.product-options');
    if (!$form.length) return;

    var color = $form.find('[data-option="Color"] input[type="radio"]:checked').val();
    var logo = $form.find('[data-option="Logo"] input[type="radio"]:checked').val();
    var upgrade = $form.find('[data-option="TacSac Upgrade"] input[type="radio"]:checked').val();
    var material = $form.find('[data-option="Material"] input[type="radio"]:checked').val();

    if (color) {
      syncThumbnailsForColor(color);
    }

    if (!window.product || typeof window.product.setSlideByColorAndLogo !== 'function') return;

    if ($form.find('[data-option="TacSac Upgrade"]').length && upgrade) {
      window.product.setSlideByColorAndLogo(color, logo, upgrade);
    } else if (material && window.product.imageSliders) {
      var $matched = window.product.imageSliders.filter('[data-color="' + color + '"][data-material="' + material + '"]');
      if ($matched.length) {
        window.product.imageSliders.removeAttr('data-active');
        $matched.attr('data-active', true);
        window.product.currentSlider = $matched;
        window.product.dontAnimateSlideTransition = true;
        window.product.currentImages = window.product.currentSlider.find('.slick-slide:not(.slick-cloned) .product-image');
        if (typeof window.product.attachSliderEvents === 'function') {
          window.product.attachSliderEvents();
        }
      }
      window.product.setSlideByColorAndLogo(color, logo);
    } else {
      window.product.setSlideByColorAndLogo(color, logo);
    }
  }

  function getOptionRadioButtons($fieldset) {
    return $fieldset.find('button.product-option-value[role="radio"]').filter(function () {
      return $(this).css('display') !== 'none';
    });
  }

  function syncProductOptionAriaChecked() {
    $('.page-product-custom-new form.product-options button.product-option-value[role="radio"]').each(function () {
      var $button = $(this);
      var input = document.getElementById($button.attr('data-radio-id'));
      if (!input || $button.css('display') === 'none') return;
      $button.attr('aria-checked', input.checked ? 'true' : 'false');
    });
  }

  function selectProductOptionRadio($button) {
    if (!$button.length || $button.css('display') === 'none') return;

    var input = document.getElementById($button.attr('data-radio-id'));
    if (!input || input.disabled) return;

    var wasChecked = input.checked;
    input.checked = true;

    var $fieldset = $button.closest('fieldset.product-option');
    getOptionRadioButtons($fieldset).attr('aria-checked', 'false');
    $button.attr('aria-checked', 'true');

    if (!wasChecked) {
      $(input).trigger('change');
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncVariantGallery();
  }

  function initCustomNewProductOptionKeyboard() {
    syncProductOptionAriaChecked();
  }

  window.initCustomNewProductOptionKeyboard = initCustomNewProductOptionKeyboard;

  var $optionForm = $('.page-product-custom-new form.product-options');

  $optionForm.off('click.productOptionA11y keydown.productOptionA11y');

  $optionForm.on('click.productOptionA11y', 'button.product-option-value[role="radio"]', function () {
    selectProductOptionRadio($(this));
  });

  $optionForm.on('keydown.productOptionA11y', 'button.product-option-value[role="radio"]', function (e) {
    var $button = $(this);
    var $fieldset = $button.closest('fieldset.product-option');
    var $buttons = getOptionRadioButtons($fieldset);
    var idx = $buttons.index($button);

    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      selectProductOptionRadio($button);
      return;
    }

    var nextIdx = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      nextIdx = (idx + 1) % $buttons.length;
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      nextIdx = (idx - 1 + $buttons.length) % $buttons.length;
    } else if (e.key === 'Home') {
      e.preventDefault();
      nextIdx = 0;
    } else if (e.key === 'End') {
      e.preventDefault();
      nextIdx = $buttons.length - 1;
    }

    if (nextIdx >= 0) {
      var $nextButton = $buttons.eq(nextIdx);
      $nextButton.focus();
      selectProductOptionRadio($nextButton);
    }
  });

  $optionForm.on('change.productOptionA11y', '.product-form-option', function () {
    syncProductOptionAriaChecked();
    syncVariantGallery();
  });

  $('.page-product-custom-new form.product-form-fixed').off('change.productOptionA11y');
  $('.page-product-custom-new form.product-form-fixed').on('change.productOptionA11y', '.select-options', function () {
    setTimeout(function () {
      syncProductOptionAriaChecked();
      syncVariantGallery();
    }, 0);
  });

  $(function () {
    initCustomNewProductOptionKeyboard();
    setTimeout(initCustomNewProductOptionKeyboard, 100);
  });

  $('.product-thumbnails-new').each(function(e) {
    var color = $(this).attr('data-color');
    $(this).slick({
      slidesToShow: 6,
      slidesToScroll: 3,
      asNavFor: '.product-images[data-color="'+color+'"]',
      dots: false,
      focusOnSelect: true
    });
  });

  // $(window).on('resize orientationChange', function(event) { 
  //   $('.product-thumbnails-new').each(function(e) {
  //     var color = $(this).attr('data-color');
  //     $(this).slick('reinit'); 
  //   });
  // });
}

function initModPickerA11y() {
  var $modable = $('.modable');
  if (!$modable.length) return;

  function syncModAriaChecked() {
    $modable.find('.mod').each(function () {
      var $mod = $(this);
      var checked = $mod.attr('data-added') === 'true';
      $mod.find('figure[role="checkbox"]').attr('aria-checked', checked ? 'true' : 'false');
    });
  }

  $modable.off('keydown.modA11y click.modA11y');
  $modable.on('keydown.modA11y', 'figure[role="checkbox"]', function (e) {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      $(this).trigger('click');
    }
  });
  $modable.on('click.modA11y', 'figure[role="checkbox"]', function () {
    setTimeout(syncModAriaChecked, 0);
  });

  syncModAriaChecked();
}

if ($('.modable').length) {
  $(function () {
    initModPickerA11y();
  });
}

if ($('.size-chart-modal').length) {
  $('.size-chart-modal').each(function () {
    var $modal = $(this);
    if ($modal.hasClass('open')) return;
    $modal.attr('aria-hidden', 'true');
    $modal.find('a[href], button, input, select, textarea, [tabindex]').attr('tabindex', '-1');
  });
}


  

